@if (stdCartDetails?.orders) {
<section [ngClass]="isSticky === true ? 'sticky' : 'header'">
  <div class="savings-total one sticky-total">
    <div class="row stickbar">
      <div class="col-md-12 col-sm-12 col-lg-12 m-0 p-0">
        <div class="orderTitleSticky">
          Order Total:
          <span *ngIf="headerLevelObj?.length==0">
            <!-- {{ subTotalVal | currency }} -->
            {{ subTotalVal | currency : 'USD' :
            'symbol' : '1.2-2' }}
            <!-- {{standardCartDetails?.subTotal?.currencyIso}} -->
          </span>
          <span *ngIf="headerLevelObj?.length>0">$--</span>
          <!-- <ng-template #noPrice>
            {{ "addToCartItems.noprice" | cxTranslate }}
          </ng-template> -->
        </div>
        <p class="fw-bold m-0 p-0">Total Savings:&nbsp;<span *ngIf="headerLevelObj?.length==0"
            class="greenfont">{{totalSavings | currency : 'USD' :
            'symbol' : '1.2-2'}}</span><span *ngIf="headerLevelObj?.length>0">$--</span></p>
      </div>
    </div>


  </div>
</section>

<section class="preheader no-print">
  <section class="col-lg-12 col-md-12 col-sm-12 col-xs-12 float-right">
    <section class="col-lg-5 col-md-5 col-sm-0 col-xs-12 p0 float-left emptyheader"></section>
    <section class="
        col-lg-3 col-md-3 col-sm-6 col-xs-12
        middle-row
        mt0
        text-right
        float-left
      ">
      <div class="totalQuantityDisplayBlock">
        <div class="quantityDisplay">
          <!-- {{ getQuantity(stdCartDetails) }} Units -->
        </div>
      </div>
      <a target="" id="continueShoppingId" data-di-id="#continueShoppingId" [routerLink]="['/Open-Catalogue/c/1']">
        <img src="../../assets/icons/{{baseSiteId}}/chevron-left.svg" alt="" class="chevron-left" />
        <!-- {{'addToCartItems.continueShopping'|cxTranslate}} -->
        Continue shopping
      </a>
    </section>
    <section class="
        col-lg-4 col-md-4 col-sm-6 col-xs-12
        text-right
        float-right
        p0
        header-links">
      <section class="save-document save-document-container mb1 mt0">
        <ng-template #popSaveTitle>
          <!-- {{'addToCartItems.saveOrderTitle'|cxTranslate}} -->
          Name your order and save it for future orders
        </ng-template>
        <ng-template #popSaveContent>
          <input type="text" class="save-order" required #name="ngModel" [(ngModel)]="saveCartName"
            (keypress)="omit_special_char($event)" maxlength="30" />
          <span *ngIf="name.errors?.required" class="common-error required">{{
            errorMsg
            }}</span>
          <span class="common-error required pt-1">{{ errorMsg }}</span>
          <div class="buttonDiv">
            <button type="reset" class="popover-close btn btn-secondary popover-cancel-button" (click)="toggleClose()">
              <!-- {{'addToCartItems.cancel'|cxTranslate}} -->
              Cancel
            </button>
            <button class="btn btn-primary popover-cancel-button" type="submit" data-di-id="di-id-3064f17d-e97cc628"
              (click)="saveOrder()">
              <!-- {{'addToCartItems.save'|cxTranslate}} -->
              Save
            </button>
          </div>
        </ng-template>
        <!--Temporary hiding add to fav using hideForNow class as its out of scope currently 4jan due to technical gap in api-->
        <a class="save-cart save-cart-img-section hideForNow" [ngbPopover]="popSaveContent"
          [popoverTitle]="popSaveTitle" triggers="manual" #p2="ngbPopover" placement="top" (click)="toggle(p2)"
          container="body" popoverClass="popover-links saveorder-incart {{baseSiteId}}" *ngIf="!punchOutKey">
          <img src="../../assets/icons/{{baseSiteId}}/saved-orders-plus.png" alt="Save order" /><span>
            <!--{{'addToCartItems.saveOrder'|cxTranslate}}-->
            Add to my favorites
          </span></a>
        <ng-template #popTitle><span>
            <!-- {{'addToCartItems.clearTitle'|cxTranslate}}  -->
            Clear cart of all products?
          </span>
        </ng-template>
        <ng-template #popContent>
          <button type="reset" class="popover-close btn white-button popover-cancel-button"
            data-di-id="di-id-d01008be-fb6e135c" (click)="toggle(p1)">
            <!-- {{'addToCartItems.cancel'|cxTranslate}} -->
            Cancel
          </button>
          <button class="btn blue-button popover-cancel-button" type="submit" data-di-id="di-id-3064f17d-e97cc628"
            (click)="clearChildCart()">
            <!-- {{'addToCartItems.clearCart'|cxTranslate}} -->
            Clear cart
          </button>
        </ng-template>
        <!-- <a class="clear-cart clear-cart-img-section" [ngbPopover]="popContent" [popoverTitle]="popTitle"
          triggers="manual" #p1="ngbPopover" placement="top" (click)="toggle(p1)" container="body"
          popoverClass="popover-links">
          <img src="../../assets/icons/trash.svg" alt="Delete" />
          <span>
            Clear cart
          </span></a> -->

        <a href="javascript:void(0)" target="" aria-label="download as" class="xls_cart xls-cart-img-section"
          id="tealium-xls" data-di-id="#tealium-xls" (click)="exportXls()">
          <img src="../../assets/icons/{{baseSiteId}}/excel_new.png" alt="" />
          <span>
            <!-- {{'addToCartItems.xls'|cxTranslate}}  -->
            XLS
          </span></a>
        <a href="javascript:void(0)" onclick="window.print();" target="" id="printLinkId" class="print-cart-img-section"
          data-di-id="#printLinkId">
          <img src="../../assets/icons/{{baseSiteId}}/print.svg" alt="" />
          <span>
            <!-- {{'addToCartItems.print'|cxTranslate}}  -->
            Print
          </span></a>
      </section>
    </section>
  </section>
</section>
<div *ngIf="deleteSuccess !== ''" class="global-alerts">
  <div class="alert alert-info alert-dismissable getAccAlert">
    <button (click)="closeAlert()" class="close closeAccAlert" aria-hidden="true" data-dismiss="alert" type="button"
      data-di-id="di-id-4f6d7b93-70563360">
      ×
    </button>
    <span class="delete-succ" [innerHTML]="deleteSuccess"></span>{{ "addToCartItems.deleteSuccessMsg" | cxTranslate }}
  </div>
</div>
<div *ngIf="addSuccess" class="global-alerts">
  <div class="alert alert-info alert-dismissable getAccAlert">
    <button (click)="closeAlert()" class="close closeAccAlert" aria-hidden="true" data-dismiss="alert" type="button"
      data-di-id="di-id-4f6d7b93-70563360">
      ×
    </button>
    {{ "addToCartItems.addProdSuccess" | cxTranslate }}
  </div>
</div>
<div *ngIf="orderBlock && showDangerAlert && productEntries?.length > 0" class="global-alerts">
  <div class="alert alert-danger alert-dismissable getAccAlert">
    <button (click)="closeDangerAlert()" class="close closeAccAlert" aria-hidden="true" data-dismiss="alert"
      type="button" data-di-id="di-id-4f6d7b93-70563360">
      ×
    </button>
    {{ "addToCartItems.orderBlockMsg" | cxTranslate }}
  </div>
</div>
<section class="standart-cart">

  <div class="row whitebg section-outer">
    <div class="col-sm-4 m-0 p-0 mb-orderSubtotal" style="border-left:4px solid #f4f2f6;">
      <aside class="
      col-md-12 col-sm-12 m-0 p-0
      right-navigation
      float-left
      left-align
      cart-main-page
    " [ngClass]="isSticky === true ? 'header' : ''" aria-label="subTotal">
        <section class="savings-total p-0 two">

          <div class="row">
            <div class="col-md-12 col-sm-12 col-lg-12 m-0 p-0">
              <div class="background-grey">

                <div class="orderTitleSticky">
                  Order Total:
                  <span *ngIf="headerLevelObj?.length==0">
                    <!-- {{ getTotalPrice(stdCartDetails) | currency }} -->
                    {{ subTotalVal | currency : 'USD' :
                    'symbol' : '1.2-2' }}
                  </span>
                  <span *ngIf="headerLevelObj?.length>0">$--</span>
                  <!-- <ng-template #noPrice>
                    {{ "addToCartItems.noprice" | cxTranslate }}
                  </ng-template> -->
                </div>
                <p class="fw-bold m-0 p-0">Total Savings:&nbsp;<span *ngIf="headerLevelObj?.length==0"
                    class="greenfont">{{totalSavings | currency : 'USD'
                    :
                    'symbol' : '1.2-2'}}</span><span *ngIf="headerLevelObj?.length>0">$--</span></p>

              </div>

            </div>
          </div>



        </section>
      </aside>

    </div>
    <div class="col-xs-12 col-sm-8 col-md-8 col-lg-8">

      <div class="row whitebgmb cart-accordion-outer">
        <section class="cart-accordion">
          <!-- accordion:start-->
          <div class="sanofi-accordion" *ngFor="let locSpecificCart of stdCartDetails.orders; let i = index">
            <div class="panel-group">
              <div class="panel panel-default">
                <div class="panel-heading">
                  <section class="first-level-acc ">
                    <section class="deli_loc clear_fix">
                      <section class="cart_shipto col-sm-6 col-md-6 col-lg-6 cart_shipto pl0">
                        <section class="firstLevel-acc cartShipToHeader ">
                          <section class="">
                            <section class="ship-address">
                              <section id="location-select">
                                <section class="location-icon">
                                  <span class="glyph-icon">
                                    <i class="fas fa-map-marker-alt icon mr-3"></i>
                                  </span>
                                </section>
                                <section class="location-Details">
                                  <span class="selected-loc">
                                    {{locSpecificCart.shipToLoc_name}}
                                    ({{locSpecificCart.shipToLoc_id}})</span>
                                  <!--<p class="ordercontctdetails">
                                     7TH AND FORRESTER STS RM B24 BSMT<br />

                                    HARRISBURG, PA 17120-0001
                                    {{locSpecificCart.shipToParty.shippingAddress.formattedAddress}} 
                                  </p>-->
                                  <!-- <span class="selected-loc">{{selectedData?.name}}
                                             {{"("+selectedData?.uid+")"}} </span> -->
                                  <!--<span class="addr-label">
                                             {{selectedData?.line1 ? selectedData?.line1+', ' : ''}}
                                             {{selectedData?.line2 ? selectedData?.line2+', ' : ''}}
                                             {{selectedData?.town ? selectedData?.town+', ' : ''}}
                                             {{selectedData?.region?.isocodeShort ? selectedData?.region?.isocodeShort+' ' : ''}}
                                             {{selectedData?.postalCode}}</span>
                                             <div class="change-loc" role="button" *ngIf="changeLocation"
                                             (click)="open(content)">{{'account.changeLocation'|
                                             cxTranslate}}</div>-->
                                </section>
                                <!-- <section class="custome-modal">
                                          <ng-template #content let-modal>
                                              <section class="modal-header cart-Modal-Header">
                                                  <button type="button" class="close" aria-label="Close"
                                                      (click)="modal.dismiss('Cross click')">
                                                      <img alt="" src="../../assets/icons/close.png">
                                                  </button>
                                                  <h4 class="modal-title" id="modal-basic-title">
                                                      {{'account.selectLocation'| cxTranslate}}</h4>
                                              </section>
                                              <section class="modal-body">
                                          
                                                  <section class="input-group loc-SearchBar">
                                                      <span class="input-group-btn">
                                                          <button class="btn" type="button">
                                                              <span class="loc-Search-Icon">
                                                              </span>
                                                          </button>
                                                          <input type="text" #clientName
                                                              (keyup)="SearchClientName(clientName.value)"
                                                              class="form-control searchboxnew"
                                                              placeholder="{{'account.filterByLocation'| cxTranslate}}	" />
                                                      </span>
                                                  </section>
                                                  <hr
                                                      [ngClass]="{'displayNone':searchedClientList?.length===0}" />
                                                  <section>
                                                      <section
                                                          [ngClass]="{'displayNone':searchedClientList?.length===0}"
                                                          class="custom-control custom-radio radio_grp label-location w-100 m-0">
                                                          <table aria-describedby="shiptolocation"
                                                              *ngFor="let data of searchedClientList;  let i = index"
                                                              class="w-100">
                                                              <tr class="sample-header">
                                                                  <th scope="col"></th>
                                                                  <th scope="col"></th>
                                                              </tr>
                                                              <tr class="line-location"
                                                                  [ngClass]="{'label-location': (i !== searchedClientList.length-1)}">
                                          
                                                                  <input type="radio"
                                                                      (change)='onOptionsSelected(data)'
                                                                      [id]="data?.id"
                                                                      [checked]="selectedData?.id == data?.id"
                                                                      name="customRadio"
                                                                      class="custom-control-input" />
                                                                  <label
                                                                      class="custom-control-label secloct w-100"
                                                                      [for]="data?.id">
                                                                      {{data?.companyName}}
                                                                      {{"("+data?.unitID+")"}}
                                                                  </label>
                                                                  <p class="labelpp"> {{data?.line1 ?
                                                                      data?.line1+', ' : ''}}
                                                                      {{data?.line2 ? data?.line2+', ' :
                                                                      ''}}
                                                                      {{data?.town ? data?.town+', ' :
                                                                      ''}}
                                                                      {{data?.region?.isocodeShort ?
                                                                      data?.region?.isocodeShort+' ' :
                                                                      ''}}
                                                                      {{data?.postalCode}}
                                                                  </p>
                                          
                                                              </tr>
                                                          </table>
                                                      </section>
                                          
                                                  </section>
                                              </section>
                                              <section class="modal-footer">
                                                  <button type="button" class="btn location-done"
                                                      (click)='onSubmit()'
                                                      (click)="modal.close('Save click')">
                                                      {{'account.done'| cxTranslate}}
                                                  </button>
                                              </section>
                                          </ng-template>
                                          </section> -->
                              </section>
                            </section>
                          </section>
                        </section>
                      </section>

                    </section>
                    <section class="ship_addr clear_fix" *ngIf="deliveryPickup=='pickup'">
                      <section class="col-sm-4 col-md-4 col-lg-4 cart_shipto pl0 float-left">
                        <h6>{{'addToCartItems.pickLocation'|cxTranslate}}</h6>
                        <p>
                          {{'addToCartItems.sanofiName'|cxTranslate}}<br>{{'addToCartItems.locationLine1'|cxTranslate}}<br>{{'addToCartItems.locationLine2'|cxTranslate}}
                        </p>
                      </section>
                      <section class=" col-sm-6 col-md-6 col-lg-6 px0 float-left" [hidden]="getExpandedItems(i)">
                        <section class="delivery-content">
                          <section class="delivary-details cart-pickup-date">
                            <h6 class="requested-date"> {{'addToCartItems.pickupDate'|cxTranslate}}</h6>
                            <section class="calender">
                              <section class="form-horizontal mb0">
                                <section class="control-group float-left">
                                  <section class="controls input-append date cart-delivery-date-picker" data-date=""
                                    data-date-format="mm/dd/yyyy" data-link-field="dtp_input2"
                                    data-link-format="mm/dd/yyyy">
                                    <span class="add-on"><i class="icon-th"></i>
                                    </span>
                                    <input type="text" placeholder="DD/MM/YYYY" class="delivery-pickup-calendar"
                                      bsDatepicker [(ngModel)]="pickupDate" [minDate]="minPickupDate"
                                      [daysDisabled]="[0,6]" [maxDate]="maxPickupDate"
                                      (bsValueChange)="onPickupDateChange($event)"
                                      [bsConfig]="{ containerClass: 'theme-green deliveryPickup' }">
                                  </section>
                                </section>
                                <ng-select [items]="timeFormat" bindLabel="name" bindValue="selectedTime"
                                  [multiple]="false" name="selectedTime" placeholder="Set Time"
                                  [(ngModel)]="selectedTime" [searchable]="false">
                                </ng-select>
                              </section>
                            </section>
                          </section>
                          <p class="pickupTextMsg">
                            {{'addToCartItems.pickupMsg'|cxTranslate}}
                            <br>{{'addToCartItems.customerService'|cxTranslate}}
                            {{'addToCartItems.customerServiceNo'|cxTranslate}}
                          </p>
                        </section>
                      </section>
                    </section>
                    <!-- <span class="accMinusIcon fa-minus acc-plus-icon fa plusMinusIcon" [hidden]="getExpandedItems(i)"
                      (click)="toggleAccordion(i)">
                    </span>
                    <span class="accPlusIcon fa-plus acc-plus-icon fa plusMinusIcon" [hidden]="!getExpandedItems(i)"
                      (click)="toggleAccordion(i)">
                    </span> -->
                  </section>
                </div>

              </div>
            </div>
            <section [hidden]="getExpandedItems(i)" class="row">

              <section class="col-lg-12 col-md-12 col-sm-12 label-location">


                <table class="alignRight location-table">
                  <tr *ngIf="locSpecificCart?.cartType !== 'INFLUENZA'">
                    <td class="ff-bold">Order #:</td>
                    <td class="fw-bold">{{locSpecificCart?.code}}</td>
                  </tr>
                  <tr *ngIf="locSpecificCart?.cartType !== 'INFLUENZA'">
                    <td class="ff-bold">PO #:</td>
                    <td class="fw-bold">
                      {{locSpecificCart?.purchaseOrderNumber!=''?locSpecificCart?.purchaseOrderNumber:locSpecificCart?.code}}
                    </td>
                  </tr>
                  <tr *ngIf="locSpecificCart?.cartType === 'INFLUENZA'">
                    <td class="ff-bold">Influenza Order #:</td>
                    <td class="fw-bold">{{locSpecificCart?.code}}</td>
                  </tr>
                  <tr *ngIf="locSpecificCart?.cartType === 'INFLUENZA'">
                    <td class="ff-bold">Influenza Vaccine PO #:</td>
                    <td class="fw-bold">
                      {{locSpecificCart?.purchaseOrderNumber!=''?locSpecificCart?.purchaseOrderNumber:locSpecificCart?.code}}
                    </td>
                  </tr>
                </table>



              </section>


            </section>


            <div class="row p-1 details-for-mb separatorLn">

              <div class="col-xs-12 col-sm-3 p-2">
                <div class="row">
                  <div class="col-12 mb-order-col">
                    <div class="order-detailsi-text order-detailsi-text-mb">Sold To</div>
                    <div>#{{locSpecificCart.shipToLoc_id}}</div>
                  </div>
                  <div class="col-12 mb-order-col">
                    <div class="order-detailsi-text  order-detailsi-text-mb">Order Date</div>
                    <div>{{getRequestedDate(locSpecificCart.created)}}</div>
                  </div>
                </div>


              </div>

              <div class="col-xs-12 col-sm-4 p-2">

                <div class="row">
                  <div class="col-12 mb-order-col">
                    <div class="order-detailsi-text  order-detailsi-text-mb shipToMobile">Ship To</div>
                    <div>
                      <div *ngIf="locSpecificCart?.shipToLoc_name && locSpecificCart?.shipToLoc_name!=''">
                        {{locSpecificCart?.shipToLoc_name}}
                      </div>
                      <!-- below was working only for single location order 
                        <div>{{shippingAddressOfLocation?.formattedAddress|uppercase}}
                      </div> -->
                      <div>{{locSpecificCart?.shippingAddressOfLocation?.formattedAddress|uppercase}}
                      </div>
                    </div>

                  </div>
                </div>
                <div class="row mt-2"
                  *ngIf="locSpecificCart?.attention !== null && locSpecificCart?.attention !== undefined">
                  <div class="col-12 mb-order-col">
                    <div class="order-detailsi-text  order-detailsi-text-mb" *ngIf="locSpecificCart?.attention">
                      Attention</div>
                    {{ locSpecificCart?.attention }}
                  </div>
                </div>

              </div>

              <div class="col-xs-12 col-sm-5">

                <div class="mb-1">

                  <span class="order-detailsi-text location-total">Location subtotal</span>

                  <span *ngIf="headerLevelObj?.length==0"
                    class="order-detailsi-text location-total-amount txt-float-right">

                    <!-- {{locSpecificCart.subTotal.value}} -- {{locSpecificCart.totalTax.value}} -->
                    {{locSpecificCart?.subTotal?.value+locSpecificCart?.totalExciseTax?.value | currency : 'USD' :
                    'symbol' : '1.2-2'}}
                  </span>
                  <span *ngIf="headerLevelObj?.length>0">$--</span>

                </div>

                <ng-container *ngIf="salesTaxFlag=='y';else salesTaxNotMandatory">
                  <div class="mb-1">
                    <span class="order-detailsi-text location-total savings-chg">Sales tax</span>
                    <span *ngIf="headerLevelObj?.length==0"
                      class="order-detailsi-text location-total-amount txt-float-right savings-chg">
                      {{locSpecificCart?.totalSalesTaxPrice?.value | currency : 'USD' :
                      'symbol' : '1.2-2'}}
                    </span>
                    <span *ngIf="headerLevelObj?.length>0">$--</span>
                  </div>
                </ng-container>
                <ng-template #salesTaxNotMandatory>
                  <div class="mb-1"
                    *ngIf="locSpecificCart?.totalSalesTaxPrice && locSpecificCart?.totalSalesTaxPrice?.value>0">
                    <span class="order-detailsi-text location-total savings-chg">Sales tax</span>
                    <span *ngIf="headerLevelObj?.length==0"
                      class="order-detailsi-text location-total-amount txt-float-right savings-chg">
                      {{locSpecificCart?.totalSalesTaxPrice?.value | currency : 'USD' :
                      'symbol' : '1.2-2'}}
                    </span>
                    <span *ngIf="headerLevelObj?.length>0">$--</span>
                  </div>
                </ng-template>

                <div class="mb-1" *ngIf="locSpecificCart.totalWebDiscount.value!=0">

                  <span class="location-total savings-chg">{{baseSiteId=="vsh"?"VaccineShop Savings":"VaxServe.comSavings"}}</span>

                  <span class="location-total-amount txt-float-right text-success savings-chg"
                    *ngIf="headerLevelObj?.length==0">{{locSpecificCart.totalWebDiscount.value
                    |
                    currency : 'USD' :
                    'symbol' : '1.2-2'}}</span>
                  <span *ngIf="headerLevelObj?.length>0">$--</span>

                </div>
                <ng-container *ngIf="otherDiscountsFlag=='y';else otherDiscNotMandatory">
                  <div class="mb-1">
                    <span class="order-detailsi-text location-total savings-chg">Other discounts
                    </span>
                    <span class="location-total-amount txt-float-right text-success savings-chg"
                      *ngIf="headerLevelObj?.length==0">{{locSpecificCart?.totalOtherDiscount?.value
                      |
                      currency : 'USD' : 'symbol' : '1.2-2'}}
                    </span>
                    <span *ngIf="headerLevelObj?.length>0">$--</span>
                  </div>
                </ng-container>
                <ng-template #otherDiscNotMandatory>
                  <div class="mb-1"
                    *ngIf="locSpecificCart?.totalOtherDiscount && locSpecificCart?.totalOtherDiscount?.value!=0">
                    <span class="order-detailsi-text location-total savings-chg">Other discounts
                    </span>
                    <span class="location-total-amount txt-float-right text-success savings-chg"
                      *ngIf="headerLevelObj?.length==0">{{locSpecificCart?.totalOtherDiscount?.value
                      |
                      currency : 'USD' : 'symbol' : '1.2-2'}}
                    </span>
                    <span *ngIf="headerLevelObj?.length>0">$--</span>
                  </div>
                </ng-template>

                <div class="mb-1 bg-color">

                  <span class="order-detailsi-text location-total">Location Total</span>

                  <span class="order-detailsi-text location-total-amount txt-float-right"
                    *ngIf="headerLevelObj?.length==0">{{locSpecificCart.totalPrice.value

                    | currency : 'USD' : 'symbol' : '1.2-2' }}</span>
                  <span *ngIf="headerLevelObj?.length>0">$--</span>

                </div>

              </div>

            </div>

            <div class="row p-1 details-for-mb">
              <div class="col-12">
                <section class="row">
                  <div class="col-md-12">
                    <div class="panel-body p-0 m-0">
                      <section class="row row-20 pdp-list-product-data">

                        <div class="col-10 leftRed"
                          *ngIf="showonHold && stdCartDetails.orders[i]?.deliveryBlock=='YD'">
                          <div class="row">
                            <div class="col-1 topMargin">
                              <p><img src="../../../../assets/icons/{{baseSiteId}}/warning_red_new.png" alt="faq_reg"
                                  class="faq" /></p>
                            </div>
                            <div class="col-10">
                              <div style="margin-top:12px;">
                                <p><strong>This order has been placed on HOLD</strong></p>
                                <p>Per your company's policy this order has been forwarded for approval to:<br />
                                  Name:&nbsp;{{stdCartDetails.orders[i]?.approver?.name}}<br />
                                  Phone:&nbsp;{{stdCartDetails.orders[i]?.approver?.phone}}<br />Once your order has
                                  been approved
                                  it
                                  will immediately be processed for shipment.<br />Thank you again for your order.
                                  Your
                                  complete order details are below..</p>

                                <p>Sincerely<br /> {{baseSiteId=="vsh"?'VaccineShop Account Management':'VaxserveAccount Management'}}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <section class="pdp-list-data"
                        *ngFor="let productentry of locSpecificCart?.entries; let j = index"
                        style="border-top:0.0625em solid #e5e9ec">

                        


                        <section class="row row-20 pdp-list-product-data">

                          <div class="col-md-1">
                            <section class="col-xs-12 col-sm-7 col-md-7 col-lg-7 pr0 cart_print">
                              <a (click)="productDetails(productentry,i)">
                                <img class="image-product" src="{{getImage(productentry.product?.images,'thumbnail')}}"
                                  alt="Product Img">

                              </a>
                            </section>
                          </div>
                          <div class="col-md-10 cart_print prodDetMobile marginleftCls">
                            <a (click)="productDetails(productentry,i)">
                              <h2 class="prod-title" [innerHTML]="productentry?.product?.baseProductName"></h2>
                            </a>
                            <section class="checkout-data">
                              <a (click)="productDetails(productentry,i)">
                                <p [innerHTML]="productentry?.product?.baseProductDescription"
                                  (click)="productDetails(productentry,i)" class="productCode prodDes"></p>
                                <p [innerHTML]="stdFluDesc(productentry)" class="productCode prodDes"
                                  (click)="productDetails(productentry,i)"></p>
                              </a>
                              <p class="ndcCode" *ngIf="productentry.product?.ndcCode">
                                {{productentry.product?.ndcCode}}</p>
                              <!-- <div *ngFor="let itm of productentry?.product?.variantOptions"> -->
                              <div>
                                <p class="card-text">
                                  <!-- <span class="num-bold">{{itm?.description}}</span><br /> -->
                                  <span><strong>{{productentry?.product?.code}}</strong> |
                                    {{productentry?.product?.manufacturer}}</span>
                                  <span *ngIf="productentry?.contractName"
                                    [ngStyle]="{ 'margin-left': '10px'}"><strong>Contract Group:</strong>
                                    {{productentry?.contractName}}</span>
                                </p>
                              </div>
                              <p class="inner-text"
                                *ngIf="productentry.product?.innerText && productentry.product?.innerText !== ''">
                                <span [innerHtml]="productentry?.product?.innerText"></span>
                              </p>
                            </section>
                          </div>



                        </section>
                        <section class="row marginleftCls">

                          <section class="col-sm-12 col-md-12 col-lg-12 data-pad">

                            <table id="example1" style="width: 100%;"
                              class="display account_invoice_financials dataTable no-footer">
                              <thead>
                                <tr class="heading">
                                  <th id="table1col1" class="date-new no-sort 1">Status</th>
                                  <th id="table1col2" class="date-new no-sort">Total Units</th>
                                  <th id="table1col3" class="invoice no-sort">Units in shipment</th>
                                  <th id="table1col4" class="po no-sort">Ship Date</th>
                                  <th id="table1col5" class="invoice-amount no-sort right">Unit Price</th>
                                  <th id="table1col6" class="discount no-sort right">Unit Excise Tax</th>
                                  <th id="table1col7" class="no-sort right">Subtotal</th>
                                </tr>
                              </thead>
                              <tbody class="datatable-row"
                                *ngIf="(!productentry?.futureShipExpProd || (productentry?.futureShipExpProd && !productentry?.splitEntriesDeliveryDates) || (productentry?.futureShipExpProd && productentry?.splitEntriesDeliveryDates && productentry?.splitEntriesDeliveryDates?.length==0 ))">
                                <tr class="odd dateshow 1">
                                  <td rowspan="2" headers="table1col 1">Open</td>
                                  <td>{{productentry?.quantity}}</td>
                                  <td>{{productentry?.quantity}}</td>

                                  <td>
                                    {{getRequestedDate(productentry?.estimatedDeliveryDate)}}<br>(Estimated)
                                  </td>

                                  <td class="right"><span
                                      *ngIf="!productentry?.product?.hidePriceForProduct">{{productentry?.basePrice?.value
                                      |
                                      currency : 'USD' :
                                      'symbol' : '1.2-2'}}</span>
                                    <span *ngIf="productentry?.product?.hidePriceForProduct">$--</span>
                                  </td>
                                  <td class="right"><span
                                      *ngIf="!productentry?.product?.hidePriceForProduct">{{productentry.exciseTax.value
                                      | currency : 'USD' :
                                      'symbol' : '1.2-2'}}</span>
                                    <span *ngIf="productentry?.product?.hidePriceForProduct">$--</span>
                                  </td>
                                  <td class="right"><span
                                      *ngIf="!productentry?.product?.hidePriceForProduct">{{(productentry.totalPrice.value+productentry.exciseTax.value*productentry?.quantity)
                                      | currency : 'USD' :
                                      'symbol' : '1.2-2'}}</span>
                                    <span *ngIf="productentry?.product?.hidePriceForProduct">$--</span>
                                  </td>
                                </tr>
                              </tbody>
                              <tbody class="datatable-row"
                                *ngIf="productentry?.futureShipExpProd && productentry?.splitEntriesDeliveryDates?.length>0">

                                <tr class="odd dateshow"
                                  *ngFor="let item of productentry.splitEntriesDeliveryDates;let i=index">

                                  <td *ngIf="i==0" [attr.rowspan]="productentry?.splitEntriesDeliveryDates?.length"
                                    headers="table1col1">{{i==0?'Open':' '}}</td>
                                  <td *ngIf="i>0"></td>

                                  <!-- <td rowspan="2" headers="table1col1" *ngIf="i>0"></td> -->

                                  <td>{{i==0?productentry.quantity:item.splitQuantity}}</td>

                                  <!-- <td *ngIf="i>0"></td> -->

                                  <!-- <td style="white-space: pre-line">

                                    {{i==0?item.splitQuantity:("Week of" +'\n'+(item.splitdeliveryDate|

                                    date:'MM/dd/yyyy'))}}

                                  </td> -->
                                  <td style="white-space: pre-line"
                                    [innerHTML]="getQtyOrShipDate(i,item.splitdeliveryDate,item.splitQuantity,'quantity')">
                                  </td>

                                  <!-- <td style="white-space: pre-line">{{i==0?("Week of" +'\n'+(item.splitdeliveryDate|

                                    date:'MM/dd/yyyy')):''}}

                                  </td> -->
                                  <td style="white-space: pre-line"
                                    [innerHTML]="getQtyOrShipDate(i,item.splitdeliveryDate,'','date')"></td>

                                  <td class="right">

                                    {{i==0?'$'+productentry?.basePrice?.value:''}}

                                  </td>

                                  <td class="right">{{i==0?(productentry.exciseTax.value| currency : 'USD' :'symbol' :
                                    '1.2-2'):''}}</td>

                                  <td class="right">

                                    {{i==0?((productentry?.basePrice?.value+productentry.exciseTax.value)*productentry.quantity|
                                    currency : 'USD' : 'symbol' : '1.2-2'):''}}

                                  </td>

                                </tr>

                              </tbody>
                            </table>
                            <table id="mb-example1" style="width: 100%;"
                              class="display account_invoice_financials dataTable no-footer">
                              <tbody class="datatable-row"
                                *ngIf="(!productentry?.futureShipExpProd || (productentry?.futureShipExpProd && !productentry?.splitEntriesDeliveryDates) || (productentry?.futureShipExpProd && productentry?.splitEntriesDeliveryDates?.length==0 ))">
                                <tr class="odd dateshow">
                                  <td class="left-td 2">Status</td>
                                  <td class="2">Open</td>
                                </tr>
                                <tr class="odd dateshow">
                                  <td class="left-td">Total Units</td>
                                  <td>{{productentry?.quantity}}</td>
                                </tr>
                                <tr class="odd dateshow">
                                  <td class="left-td">Units in shipment</td>
                                  <td>{{productentry?.quantity}}</td>
                                </tr>
                                <tr class="odd dateshow">
                                  <td class="left-td">Ship Date</td>
                                  <!-- <td>{{getRequestedDate(locSpecificCart.requestedDeliveryDate)}}
                                    <br>(Estimated)
                                  </td> -->
                                  <td>
                                    <!-- {{isFutershipAdded==false?getRequestedDate(locSpecificCart.requestedDeliveryDate):getRequestedDate(productentry?.estimatedDeliveryDate)}}<br>(Estimated) -->
                                    {{getRequestedDate(productentry?.estimatedDeliveryDate)}}<br>(Estimated)
                                  </td>
                                </tr>
                                <tr class="odd dateshow">
                                  <td class="left-td">Unit Price</td>
                                  <td class="right">{{productentry?.totalPrice?.value | currency : 'USD' :
                                    'symbol' : '1.2-2'}}
                                  </td>
                                </tr>
                                <tr class="odd dateshow">
                                  <td class="left-td">Unit Excise Tax</td>
                                  <td class="right">{{productentry.exciseTax.value | currency : 'USD' :
                                    'symbol' : '1.2-2'}}</td>
                                </tr>
                                <tr class="odd dateshow">
                                  <td class="left-td">Subtotal</td>
                                  <td class="right">
                                    {{(productentry.totalPrice.value+productentry.exciseTax.value*productentry?.quantity)
                                    |
                                    currency : 'USD' :
                                    'symbol' : '1.2-2'}}
                                  </td>
                                </tr>
                              </tbody>
                              <tbody class="datatable-row"
                                *ngIf="productentry?.futureShipExpProd && productentry?.splitEntriesDeliveryDates?.length>0">

                                <tr class="odd dateshow"
                                  *ngFor="let item of productentry.splitEntriesDeliveryDates;let i=index">

                                  <td [attr.rowspan]="productentry?.splitEntriesDeliveryDates?.length"
                                    headers="table1col1">{{i==0?'Open':' '}}</td>

                                  <!-- <td rowspan="2" headers="table1col1" *ngIf="i>0"></td> -->

                                  <td>{{i==0?productentry.quantity:item.splitQuantity}}</td>

                                  <!-- <td *ngIf="i>0"></td> -->

                                  <!-- <td style="white-space: pre-line">

                                    {{i==0?item.splitQuantity:("Week of" +'\n'+(item.splitdeliveryDate|

                                    date:'MM/dd/yyyy'))}}

                                  </td> -->
                                  <td style="white-space: pre-line"
                                    [innerHTML]="getQtyOrShipDate(i,item.splitdeliveryDate,item.splitQuantity,'quantity')">
                                  </td>

                                  <!-- <td style="white-space: pre-line">{{i==0?("Week of" +'\n'+(item.splitdeliveryDate|

                                    date:'MM/dd/yyyy')):''}}

                                  </td> -->
                                  <td style="white-space: pre-line"
                                    [innerHTML]="getQtyOrShipDate(i,item.splitdeliveryDate,'','date')"></td>

                                  <td class="right">

                                    {{i==0?'$'+productentry?.basePrice?.value:''}}

                                  </td>

                                  <td class="right">{{i==0?(productentry.exciseTax.value|currency:'USD'
                                    :'symbol':'1.2-2'):''}}</td>

                                  <td class="right">

                                    {{i==0?(((productentry?.basePrice?.value+productentry.exciseTax.value)*productentry.quantity)|currency:'USD':'symbol'
                                    : '1.2-2'):''}}

                                  </td>

                                </tr>

                              </tbody>
                            </table>
                          </section>
                          <!-- <section class="col-sm-3 col-lg-3 col-md-2 price-list">
                          <section class="product-price">
                            <h6>
                              {{'plp.yourPrice'|cxTranslate}}
                            </h6>
                            <span>{{productentry?.totalPrice?.value | currency}}
                              {{productentry?.totalPrice?.currencyIso}}
                            </span><br>
                            <span class="priceTaxBlock" *ngIf="productentry?.sim_excise_tax.value > 0.00">
                              {{productentry?.sim_excise_tax.value | currency}}
                              {{productentry?.sim_excise_tax?.currencyIso}}/ {{productentry?.product?.unit}} federal
                              excise tax will be added.
                            </span>
                          </section>
                        </section> -->

                          <!-- <section class="col-lg-2 col-md-2 col-sm-2 hidden-xs
                             delete-popover-container-rwd min-col-width pr0 width13 no-print">
                          <ng-template #popTitleDelete1>
                            Delete this item from your cart?
                          </ng-template>
                          <ng-template #popContentDelete1>
                            <button type="reset" class="popover-close btn white-button popover-cancel-button"
                              data-di-id="di-id-d01008be-fb6e135c" (click)="toggle(p1)">
                              Cancel
                            </button>
                            <button class="btn blue-button popover-cancel-button" type="submit"
                              data-di-id="di-id-3064f17d-e97cc628"
                              (click)="deleteCart(productentry?.entryNumber,productentry?.product?.name,i)">
                              Delete
                            </button>
                          </ng-template>
                          <a [ngbPopover]="popContentDelete1" [popoverTitle]="popTitleDelete1" triggers="manual"
                            #p10="ngbPopover" placement="top" class="trash cart-edit-delete" (click)="openPopover(p10)">
                            <img src="../../assets/icons/trash.svg" alt="Delete">
                            Delete
                          </a>
                        </section> -->
                        </section>
                      </section>
                    </div>
                  </div>
                </section>
              </div>
            </div>






          </div>
          <!-- accordion: end-->
        </section>
      </div>

    </div>
    <div class="col-sm-4 col-md-4 col-lg-4 m-0 p-0" style="border-left:4px solid #f4f2f6;">
      <aside class="
      col-md-12 col-sm-12 m-0 p-0
      right-navigation
      float-left
      left-align
      cart-main-page dst-orderSubtotal
    " [ngClass]="isSticky === true ? 'header' : ''" aria-label="subTotal">
        <section class="savings-total p-0 two">

          <div class="row">
            <div class="col-md-12 col-sm-12 col-lg-12 m-0 p-0">
              <div class="background-grey">

                <div class="orderTitleSticky">
                  Order Total:
                  <span *ngIf="headerLevelObj?.length==0">

                    {{ subTotalVal | currency : 'USD' :
                    'symbol' : '1.2-2' }}
                  </span>
                  <span *ngIf="headerLevelObj?.length>0">$--</span>

                </div>
                <p class="fw-bold m-0 p-0">Total Savings:&nbsp;<span *ngIf="headerLevelObj?.length==0"
                    class="greenfont">{{totalSavings | currency : 'USD'
                    : 'symbol' : '1.2-2'}}</span><span *ngIf="headerLevelObj?.length>0">$--</span> </p>

              </div>

            </div>
          </div>



        </section>

        <section>
          <!-- <app-order-products></app-order-products> -->

        </section>


      </aside>
      <aside class="
      col-md-12 col-sm-12
      right-navigation
      float-left
      left-align
      cart-main-page
    " aria-label="subTotal">
        <div class="p-0 m-0" [class.payMethod-marTop]="isSticky">
          <app-payment-method [orderFlu]="true" [stdCartType]="true" [cancelFluReservation]="true"
            [paymentMethod]="stdCartDetails?.orders[0]?.paymentMethod" [cardDetails]="cardDetails"></app-payment-method>
        </div>
      </aside>
      <aside class="
      col-md-12 col-sm-12
      right-navigation
      float-left
      left-align
      cart-main-page
    " aria-label="subTotal">
        <div class="row">
          <div class="col-md-12 col-sm-12">
            <h2 class="orderContact">
              Order contact</h2>
          </div>
        </div>

        <!--Payment Method-->
        <div class="reserve-contact">


          <div class="row">
            <div class="col-md-4 formLabel productCode productCodeMb">Order placed by</div>
            <div class="col-md-8 fw-normal-contact">{{stdCartDetails?.orders[0]?.orderContactData?.name}}</div>
          </div>

          <div class="row" *ngIf="showphoneNo">
            <div class="col-md-4 formLabel productCode productCodeMb">Phone</div>
            <div class="col-md-8 fw-normal-contact">{{stdCartDetails?.orders[0]?.orderContactData?.phoneNo}}</div>
          </div>

          <!-- <div class="row" *ngIf="showphoneNo">
            <div class="col-md-2 formLabel productCode productCodeMb">Phone</div>
            <div class="col-md-8 fw-normal-contact">{{stdCartDetails?.orders[0]?.orderContactData.phoneNo}}</div>

          </div> -->

          <div class="row" *ngIf="showmobileNo">
            <ng-template #errorPopContent>Add mobile number to receive shipping/delivery texts</ng-template>
            <div class="col-md-4 formLabel productCode productCodeMb">Mobile<a placement="top"
                [ngbPopover]="errorPopContent"><img src="../../../../assets/icons/{{baseSiteId}}/faqs-plum.svg"
                  alt="faq_reg" class="faq" /></a></div>
            <div class="col-md-8 fw-normal-contact">{{stdCartDetails?.orders[0]?.orderContactData.mobileNo}}</div>
          </div>
          <ng-container *ngIf="stdCartDetails?.orders[0]?.orderContactData?.additionalMobiles?.length > 0">

            <div class="row" *ngFor="let mob of stdCartDetails?.orders[0]?.orderContactData?.additionalMobiles">

              <div class="col-md-4 formLabel"></div>

              <div class="col-md-8 fw-normal-contact">{{mob}}</div>

            </div>

          </ng-container>


          <div class="row" *ngIf="stdCartDetails?.orders[0]?.orderContactData?.email!=''">
            <div class="col-md-4 formLabel productCode productCodeMb">Email</div>
            <div class="col-md-8 fw-normal-contact formVal"><a class="reservation_email fw-normal-contact formVal"
                href="mailto:{{stdCartDetails?.orders[0]?.orderContactData.email}}">{{stdCartDetails?.orders[0]?.orderContactData.email}}</a>
            </div>
          </div>
          <ng-container *ngIf="stdCartDetails?.orders[0]?.orderContactData?.additionalEmails?.length > 0">

            <div class="row" *ngFor="let email of stdCartDetails?.orders[0]?.orderContactData?.additionalEmails">

              <div class="col-md-4 formLabel"></div>

              <div class="col-md-8 fw-normal-contact formVal">

                <a class="reservation_email fw-normal-contact formVal" href="mailto:{{email}}">{{email}}</a>

              </div>

            </div>

          </ng-container>
          <div class="row" *ngIf="stdCartDetails?.orders[0]?.orderContactData?.fax!=''">
            <div class="col-md-4 formLabel productCode productCodeMb">Fax</div>
            <div class="col-md-8 fw-normal-contact">{{stdCartDetails?.orders[0]?.orderContactData.fax}}
            </div>
          </div>




          <div class="row">
            <div class="col-md-4 formLabel productCode productCodeMb">Placed By</div>
            <div class="col-md-8 fw-normal-contact">{{stdCartDetails?.orders[0]?.orderContactData?.placedBy ?
              stdCartDetails?.orders[0]?.orderContactData?.placedBy :
              stdCartDetails?.orders[0]?.orderContactData?.name}}</div>

          </div>
          <div class="row" *ngIf="isAsmUser && stdCartDetails?.orders[0]?.orderContactData?.salesRepEmail">
            <div class="col-md-4 formLabel productCode productCodeMb">Email</div>
            <div class="col-md-8 fw-normal-contact formVal"><a class="reservation_email fw-normal-contact formVal"
                href="mailto:{{stdCartDetails?.orders[0]?.orderContactData?.salesRepEmail}}">{{stdCartDetails?.orders[0]?.orderContactData?.salesRepEmail}}</a>
            </div>
          </div>


          <!-- <div class="row" style="margin-left:10px;" *ngIf="editContact">
            <div class="col-md-12 formLabel">Email</div>
            <div class="col-md-18 formValue" *ngIf="editContact"><input disabled type="text"
                [(ngModel)]="contactDetails.contactEmail" onkeydown="return /[a-z]/i.test(event.key)" class="formElement">
            </div>
          </div> -->



        </div>
        <!--End of Payment Method-->


        <div class="row">
          <div class="col-md-6 col-sm-6 mobileWidthPadding">
            <h3 class="productCode">Billing Address</h3>



            <p class="dataforaddblock">{{orderContactDetails?.accountNumber}}<br />
              <span *ngIf="orderContactDetails?.companyName">{{orderContactDetails?.companyName}}<br /></span>
              <!-- CTR FOR DISEASE CONTROL AND PREV<br /> -->

              {{orderContactDetails?.formattedAddress}}
            </p>
          </div>
          <div class="col-md-6 col-sm-6 mobileWidthPadding">
            <h3 class="productCode">Payer address</h3>
            <p class="dataforaddblock">{{payerAddress?.accountNumber}}<br />
              <span *ngIf="payerAddress?.companyName">{{payerAddress?.companyName}}<br /></span>
              <!-- CTR FOR DISEASE CONTROL AND PREV<br /> -->

              {{payerAddress?.formattedAddress}}
            </p>
          </div>
        </div>
      </aside>
    </div>
  </div>

  <!-- <div class="row whitebg">
    <div class="col-sm-10">
      <section class="
      col-md-10 col-sm-10
      left-section
      float-left
      cart-left
      section-height
    ">

      </section>
    </div>

  </div> -->
</section>
<ng-template #emptyCart>
  <app-empty-cart compName="EmptyCartParagraphComponent"></app-empty-cart>
</ng-template>

<ng-template #content let-modal>
  <div class="modal-header">
    <h3 class="modal-title modalTitle">Ready to place your order?</h3>
    <!-- <button class="btn-close" (click)="modal.dismiss()"></button> -->
  </div>
  <div class="modal-body">

    <div class="row">
      <div class="col-md-12 col-sm-12 col-lg-12">
        <div class="fw-bold-center marginleftCls p-0">Order total</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-sm-12 col-lg-12">
        <div class="fw-bold-centr-amount marginleftCls">$61.62</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-sm-12 col-lg-12">
        <div class="no-sort-center marginleftCls p-0">Total with Prompt Pay: $60.46</div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 col-sm-12 col-lg-12 separator">
        &nbsp;
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 col-sm-12 col-lg-12">
        <div class="fw-bold-center marginleftCls p-0">Ship to locations</div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 col-sm-12 col-lg-12">
        <div class="fw-bold-center marginleftCls p-0">Address</div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 col-sm-12 col-lg-12 separator">
        &nbsp;
      </div>
    </div>


    <div class="row">
      <div class="col-md-6 col-sm-6 col-lg-6">
        <div class="fw-bold-center marginleftCls p-0">Order Contact</div>
      </div>

      <div class="col-md-6 col-sm-6 col-lg-6">
        <div class="fw-bold-center marginleftCls p-0">Payment Method</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-sm-6 col-lg-6">
        <div class="fw-bold-center marginleftCls p-0">Order Contact</div>
      </div>

      <div class="col-md-6 col-sm-6 col-lg-6">
        <div class="fw-bold-center marginleftCls p-0">Payment Method</div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 col-sm-12 col-lg-12 separator">
        &nbsp;
      </div>
    </div>

    <div class="row m-0 p-0">
      <div class="col-lg-9 col-sm-9 col-md-9">
        <button *ngIf="!updateTotal" type="button" class="btn btn-default blue-button mt2 placeOrderBtn"
          (click)="proceedtoFinal()" [disabled]="orderBlock || checkoutClicked || yfEntry"
          [ngClass]="orderBlock || yfEntry ? 'disableCTA' : ''">
          <i class="fa fa-spinner fa-spin" *ngIf="checkoutClicked"></i>
          Yes, place order
        </button>
        <button class="btn btn-default white-button mt2 EditOrderBtn" (click)="modal.dismiss()">
          Edit Order
        </button>
      </div>
    </div>

  </div>
  <!-- <div class=" modal-footer">
          <button class="btn" ngbAutofocus (click)="modal.dismiss()">Done</button>
      </div> -->
</ng-template>
}